import MomentDetails from '../../../MomentDetails'
import { TooltippedStoryHeading } from '../../../StoryHeading'
import type { Moment } from '../../momentCardTypes'

type HeadingAndDetailsProps = {
  moment: Moment
}

export const HeadingAndDetails: React.FC<HeadingAndDetailsProps> = ({
  moment,
}) => (
  <MomentDetails moment={moment} classPrefix="momentCard">
    <TooltippedStoryHeading moment={moment} />
  </MomentDetails>
)
